// extracted by mini-css-extract-plugin
export default {"header":"ProfitAndLossProjectionFormHeader_header__S-Nxi"};